import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@services/translate/translate.service';

@Component({
    selector: 'add-items-from-list.component',
    templateUrl: './add-items-from-list.component.html',
    styleUrls: ['./add-items-from-list.component.scss'],
    standalone: false
})
export class AddItemsFromList {
  content: any[];
  columns = [{ prop: 'title' }, { prop: 'packageInstalledAppId' }];
  idField = 'packageInstalledAppId';
  selectedItemIds = [];
  service;
  params;
  titleTranslation = 'userAdmin.frontend-group.secured';

  constructor(private dialogRef: MatDialogRef<AddItemsFromList>, @Inject(MAT_DIALOG_DATA) public data: any, private translate: TranslateService) {
    this.content = [];
    this.content = data.availableItems;
    this.columns = data.columns || this.columns;
    this.idField = data.idField || this.idField;
    this.service = data.service;
    this.params = data.params;
    this.titleTranslation = data.titleTranslation;
    this.translate.get('');
  }

  checked(event: any) {
    if (event.checked) {
      if (!this.selectedItemIds.includes(event.row[this.idField])) {
        this.selectedItemIds.push(event.row[this.idField]);
      }
    } else {
      if (!!this.selectedItemIds.includes(event.row[this.idField])) {
        this.selectedItemIds.splice(this.selectedItemIds.findIndex(el => el === event.row[this.idField]), 1);
      }
    }
  }

  abort() {
    this.dialogRef.close();
  }

  save() {
    this.dialogRef.close({ additionalItems: this.selectedItemIds });
  }
}
